export const DayCountTypes = {
  act365: 1,
  act360: 2,
  '30360': 3,
  actActIsda: 4,
  actActIcma: 5,
} as const;
